import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a0b05db"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "time-line position-relative"
}
const _hoisted_2 = { class: "flag fw-bold" }
const _hoisted_3 = { class: "title fw-bold item text-break break-spaces" }
const _hoisted_4 = { class: "d-flex align-content-center text-break break-spaces" }
const _hoisted_5 = { class: "item-name me-2" }
const _hoisted_6 = { class: "d-flex align-content-center" }
const _hoisted_7 = { class: "item-name me-2" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "item-date" }
const _hoisted_10 = {
  key: 1,
  class: "time-line position-relative mt-5"
}
const _hoisted_11 = { class: "flag fw-bold" }
const _hoisted_12 = { class: "item-name fw-bold item" }
const _hoisted_13 = { class: "detail-item" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "item-date" }

import { computed } from 'vue'
import { useStore } from 'vuex'
import TargetTag from '@/components/target-tag/index.vue'

import { translate } from '@/languages/i18n'
import { ACCOUNT_STORE } from '@/store/constants'
import { displayWorkingPeriod } from '@/constants/datepicker'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const profileDetail = computed(() => store.getters[ACCOUNT_STORE.GETTERS.PROFILE_DETAIL]?.profileDetail)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(profileDetail).portfolio_work_history_corporations?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(translate)('workExperience')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(profileDetail).portfolio_work_history_corporations, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.name
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.portfolio_work_histories, (work, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "detail-item",
                  key: index
                }, [
                  _createElementVNode("h3", null, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(work.department_name) + " " + _toDisplayString(work.position), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, _toDisplayString(work.job_type_child), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(displayWorkingPeriod)(work.start_period, work.end_period)), 1)
                  ]),
                  _createVNode(TargetTag, {
                    data: work.content,
                    class: "item-description"
                  }, null, 8, ["data"])
                ]))
              }), 128))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(profileDetail).portfolio_personal_activities?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(translate)('personalActivity')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(profileDetail).portfolio_personal_activities, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.title
            }, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(displayWorkingPeriod)(item.start_period, item.end_period)), 1)
                ]),
                _createVNode(TargetTag, {
                  data: item.content,
                  class: "item-description"
                }, null, 8, ["data"])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})